import React, { useCallback, useEffect, useState } from "react";
import { Tabs } from "client/CommonComponents";
import AppArea from "./AppArea";
import AppListing from "./AppListing";
import AppOnboarding from "./AppOnboarding";
import CategoryManagement from "./CategoryManagment";
import { PivotItem } from "@fluentui/react";
import { appOnboardingInitialForm, appOnboardingInitialFormError } from "../../utils/constant";
import userMangeOperation from '../../../../../redux/UserManagement/operations'
import userManageSelectors from '../../../../../redux/UserManagement/selectors'
import { useDispatch, useSelector } from "react-redux";
import { SetAddApplication, setApplicationById, setApplicationIcon, setCheckApplication, setDeleteApplication, uploadApplicationIcon } from "redux/UserManagement/action";
import { popupInitialData } from "utils";
import { commonPopupDisplay } from "../../utils/AdministrationUtils";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import SuccessBee from  '../../../../assets/images/SuccessBee.svg';
import { ACCESS_DENIED } from "client/utils/Permissions";

const AppOnboardingConatiner = () => {
  const [applicationForm, setApplicationForm] = useState<any>(appOnboardingInitialForm);
  const [applicationFormError, setApplicationFormError] = useState(appOnboardingInitialFormError);
  const [selectedKey, setSelectedKey] = React.useState("app-listing");
  const [selectedOption, setSelectedOption] = React.useState("");
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
  const [isAdding, setIsAdding] = useState<boolean>(false)
  const [selectedName, setSelectedName] = useState("")
  const [selectedId, setSelectedId] = useState(0)
  const [applicationDetail, setApplicationDetail] = useState<any>([])
  const [isSubmit, setIsSubmit] = useState(false);
  const [tagValue, setTagValue] = useState([""]);
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  const dispatch = useDispatch()
  const dispatchCheckApplication = userMangeOperation.dispatchGetCheckApplication(dispatch)
  const dispatchGetAddApplication = userMangeOperation.dispatchGetAddApplication(dispatch)
  const dispatchGetApplicationList = userMangeOperation.dispatchGetApplicationList(dispatch);
  const dispatchDeleteApplication = userMangeOperation.dispatchDeleteApplication(dispatch);

  const { 
      applicationCheck, 
      isCheck, 
      applicationById, 
      deleteApplication, 
      addApplicationVal, 
      isApplicationCheck,
      applicationIcon 
    }: any = useSelector((state: any) => ({
    applicationCheck: userManageSelectors.checkApplication(state),
    isCheck: state.UserManagement.isCheck,
    applicationById: state.UserManagement.applicationById,
    deleteApplication: state.UserManagement.deleteApplication,
    addApplicationVal: state.UserManagement.addApplicationVal,
    isApplicationCheck: userManageSelectors.isApplicationCheck(state),
    applicationIcon: state.UserManagement.applicationIcon
  }))

   const [userprofileinfo, setuserprofileinfo] = useState<any>({
    imagename: "",
    imguploaded: false,
    profileImageError: ""
  });


  useEffect(() => {
    if(applicationIcon !== undefined && applicationIcon !== "") {
      setApplicationForm({ ...applicationForm, logoBlobUrl: applicationIcon[0] });
      setuserprofileinfo({ ...userprofileinfo, imguploaded: true, profileImageError: "" })
    } else if (applicationIcon !== undefined) {
      setApplicationForm({ ...applicationForm, logoBlobUrl: "" });
      setuserprofileinfo({ ...userprofileinfo, imguploaded: false, profileImageError: "Error Occured while uploading the image" })
    }
    dispatch(setApplicationIcon(undefined))
  }, [applicationIcon])


  const handleLinkClick = (item?: PivotItem) => {
    if (item) {
      setSelectedKey(item.props.itemKey!);
    }
  };

  const validation: any = (name: any, value: any) => {
    let error = { ...applicationFormError };
    switch (name) {
      case "appName":
        if (value === undefined || value === "" || value === null) {
          error.appNameError = "Please enter App Name";
        } else {
          error.appNameError = "";
        }
        break;
      case "tooltipdesc":
        if (value === undefined || value === "" || value === null) {
          error.tooltipdescError = "Please enter Tooltip Description";
        } else {
          error.tooltipdescError = "";
        }
        break;
      case "category":
        if (value === undefined || value === "" || value === null || value?.value === null) {
          error.categoryError = "Please select Category";
        } else {
          error.categoryError = "";
        }
        break;
      case "logoImageSize":
        if (value != null) {
          error.logoImageError = "";
          if (value < 150) {
            error.logoImageSizeError = "Logo image should be less than 150kb";
          }
          else {
            error.logoImageSizeError = "";
          }
        }
        break;
        case "logoImage":
          if (value == "") {
            error.logoImageError = "Please select any image to upload";
          }
          else {
            error.logoImageError = "";
          }
        break;
      case "logoImageFormat":
        if (value != null) {
          error.logoImageError = "";
          if (value != "jpg") {
            if (value != "png") {
              error.logoImageFormatError = "Logo image should be in .jpg or .png format";
            }
            else {
              error.logoImageFormatError = "";
            }
          }
          else {
            error.logoImageFormatError = "";
          }
        }
        break;
    }
    return error;
  }

  const handleChange = (event: any, item: any) => {
    let value = item;
    let name = event.target.getAttribute('name') || event.currentTarget.getAttribute('name')
    setApplicationForm({ ...applicationForm, [name]: value });
    let formValidationError: any = {};
    let formValidation = validation(name, value);
    formValidationError[name + 'Error'] = formValidation[name + 'Error']
    setApplicationFormError({ ...applicationFormError, [name + 'Error']: formValidation[name + 'Error'] })
  };

const onUploadClick = () => {
  if(applicationForm?.files){
    let formData = new FormData()
    formData.append('Files', applicationForm?.files[0])
    formData.append('ApplicationName', applicationForm?.appName)
    dispatch(uploadApplicationIcon(formData))
  }
}

  const onChangeLogo = (e: any) => {
    const imgsrc = URL.createObjectURL(e.target.files[0])
    if (e.target.files[0]) {
      const filesize = Math.round((e.target.files[0].size * 0.001) * 100) / 100;
      const fileType = e.target.files[0].name.split('.')[1];
      let imagename = e.target.files[0].name;
      if (filesize < 150) {
        imagename = e.target.files[0].name;
        setApplicationForm({ ...applicationForm, logoBlobUrl: imgsrc });
        let errorValue = validation('logoImageFormat', fileType);
        setApplicationFormError({ ...errorValue });
        if (fileType != "png") {
          if (fileType != "jpg") {
            setApplicationForm({ ...applicationForm, fileName: ""});
            setuserprofileinfo({ ...userprofileinfo, imagename: imagename, profileImageError: "App Logo image's format must be .jpg or .png format." })
            let errorValue = validation('logoImageFormat', fileType);
            setApplicationFormError({ ...errorValue });
            return false;
          }
        }
        let errorMsg = validation('logoImage', e.target.files[0].name);
        setApplicationFormError({ ...errorMsg });
        let reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event: any) => {
          const image: any = new Image();
          image.src = event.target.result;
          setApplicationForm({ ...applicationForm, files: e.target.files, fileName: imagename });
          setuserprofileinfo({ ...userprofileinfo, imagename: imagename, profileImageError: "" })
        }
        setuserprofileinfo({ ...userprofileinfo, imagename: imagename, profileImageError: "" })
      } else {
        setApplicationForm({ ...applicationForm, logoBlobUrl: "" });
        setuserprofileinfo({ ...userprofileinfo, imagename: imagename, profileImageError: "Profile image shoule be less than 150kb" })
        let errorValue = validation('logoImageSize', filesize);
        setApplicationFormError({ ...errorValue });
      }
    }
  }

  const handleSubmit = () => {
    setIsSubmit(true)
    let valid = true;
    let formValError: any = {};
    for (let key in applicationForm) {
      if (key == "appName" || key == "category" || key == "tooltipdesc") {
        let formVal = validation(key, applicationForm[key]);
        formValError[key + 'Error'] = formVal[key + 'Error'];
        if (formVal[key + 'Error']) {
          valid = false;
        }
      } else if (key == "logoBlobUrl") {
        formValError['logoImageFormatError'] = applicationFormError.logoImageFormatError;
        formValError['logoImageSizeError'] = applicationFormError.logoImageSizeError;
        if (applicationFormError.logoImageFormatError || applicationFormError.logoImageSizeError) {
          valid = false;
        }
      }
    }
    setApplicationFormError({ ...formValError })

    if (valid == true) {
      let filledVal: any = {
        id: applicationById.hasOwnProperty("id") ? applicationById.id : 0,
        applicationName: applicationForm.appName,
        description: applicationForm.tooltipdesc,
        isActive: applicationForm.isActive,
        categoryId: parseInt(applicationForm.category.key),
        categoryName: applicationForm.category.text,
        applicationIconBlobURL: applicationForm.logoBlobUrl ? applicationForm.logoBlobUrl : "",
        tag: tagValue.toString(),
        fileName: applicationForm?.fileName,
        applicationURL: applicationForm?.appUrl ? applicationForm?.appUrl : ""
      }
      setApplicationDetail(filledVal)
    }
  };

  useEffect(() => {
    if (isSubmit && applicationDetail?.applicationName) {
      dispatchCheckApplication(applicationDetail)
    }
  }, [applicationDetail])
  useEffect(() => {
    if (applicationCheck && applicationDetail?.applicationName) {
      dispatchGetAddApplication(applicationDetail)
      setApplicationDetail([])
      setTagValue([])
      setIsAdding(true)
    }
    else if (applicationCheck && isSubmit) {
      let message = "Application Name given is already exist."
      commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      setIsSubmit(false)
    }
  }, [applicationCheck, isCheck])
  useEffect(() => {
    if (addApplicationVal != undefined && addApplicationVal != 0 && isSubmit) {
      if (addApplicationVal > 0 && !applicationCheck) {
        var message: any = "";
        if((applicationById.hasOwnProperty("id") && applicationById.id != 0)){
          message = "Application has been updated successfully";
        }else{
          message = `Application has been created successfully with id ` + addApplicationVal;
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, SuccessBee, "SUCCESS", handleClickPopup)
      } else if ((applicationCheck && addApplicationVal == 0 && isApplicationCheck) || (addApplicationVal == "error")) {
        var message: any = "";
        if(addApplicationVal == "error"){
          message = "Error Occured while processing the request."
        }else{
          message = "Application Name given is already exist."
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      }
      setIsSubmit(false)
      setIsAdding(false)
    }
  }, [addApplicationVal, isAdding])
  const handleDeleteClick = () => {
    dispatchDeleteApplication(selectedId)
    setSelectedId(0)

  }
  useEffect(() => {
    if (deleteApplication) {
      setShowDeleteModal(false);
      setShowInfoModal(true)
      dispatch(setDeleteApplication(false))
    }
  }, [deleteApplication])
  const handleInfoModal = () => {
    setShowInfoModal(false);
    setSelectedName("")
    dispatchGetApplicationList()
  }
  const handleDeleteModal = () => {
    setShowDeleteModal(false);
  };
  const handleClickPopup = () => {
    hideDialog()
    setSelectedKey("app-listing")
    dispatchGetApplicationList()
    setApplicationForm(appOnboardingInitialForm)
    setApplicationFormError(appOnboardingInitialFormError)
    setTagValue([])
    dispatch(setCheckApplication(true))
    dispatch(setApplicationById([]))
    dispatch(setApplicationById(appOnboardingInitialForm))
    dispatch(SetAddApplication(0))
  }
  const handleFailurePopup = () => {
    hideDialog()
    dispatch(SetAddApplication(0))
  }
  const handleClickCancel = () => {
    setSelectedKey("app-listing")
  }
  useEffect(() => {
    if (applicationById?.appName != "") {
      let val: any = [];
      val = (applicationById?.tag?.split(","))
      setTagValue(val)
      setApplicationForm({
        ...applicationForm, appName: applicationById?.applicationName,
        tooltipdesc: applicationById?.description,
        isActive: applicationById?.isActive,
        category: { key: applicationById?.categoryId?.toString(), value: applicationById.categoryId?.toString() },
        appUrl: applicationById?.applicationURL,
        logoBlobUrl: applicationById?.applicationIconBlobURL,
        fileName: applicationById?.fileName
      })
      if (selectedOption == "edit" || selectedOption == "view") {
        setuserprofileinfo({ ...userprofileinfo, imagename: applicationById?.fileName, imguploaded: true, profileImageError: "" })
      }
    }
  }, [applicationById?.id])

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  const tabItems = [
    {
      itemKey: "app-listing",
      headerText: "App Listing",
      content: <AppListing setSelectedKey={setSelectedKey}
        setSelectedOption={setSelectedOption}
        setShowDeleteModal={setShowDeleteModal}
        setSelectedId={setSelectedId}
        setSelectedName={setSelectedName}
        showDeleteModal={showDeleteModal}
        handleDeleteClick={handleDeleteClick}
        handleDeleteModal={handleDeleteModal}
        handleInfoModal={handleInfoModal}
        showInfoModal={showInfoModal}
        selectedName={selectedName}
      />,
    },
    {
      itemKey: "app-onboarding",
      headerText: "App Onboarding",
      content: (
        <AppOnboarding
          applicationForm={applicationForm}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          applicationFormError={applicationFormError}
          handleClickPopup={handleClickPopup}
          handleFailurePopup={handleFailurePopup}
          setApplicationForm={setApplicationForm}
          selectedOption={selectedOption}
          handleClickCancel={handleClickCancel}
          onChangeLogo={onChangeLogo}
          setTagValue={setTagValue}
          tagValue={tagValue}
          setApplicationFormError={setApplicationFormError}
          userProfileInfo={userprofileinfo}
          onUploadClick = {onUploadClick}
          Popupcontent = {Popupcontent}
        />
      ),
    },
    {
      itemKey: "app-area",
      headerText: "App Area",
      content: <AppArea />,
    },
    {
      itemKey: "category-management",
      headerText: "Category Management",
      content: <CategoryManagement />,
    },
  ];
  const handleContent = (status?: boolean) => {
    if (status) {
      return (
        <div className="access-denied">
          <h1>ACCESS DENIED</h1>
          <h6>{ACCESS_DENIED}</h6>
        </div>
      );
    } else {
      return (
        <>
          <h5 className="mt-3">App Onboarding</h5>
          <div className="adminCardClass p-3">
            <div className="right-block">
              <div>
                <Tabs
                  className={`custom-tab `}
                  tabItems={tabItems}
                  selectedKey={selectedKey}
                  handleLinkClick={handleLinkClick}
                 data-attribute="AppOnboarding_container_Default_Tabs" />
              </div>
            </div>
          </div>
        </>
      );
    }
  }

  return (
    <>
      {handleContent(true)}
    </>
  );
};

export default AppOnboardingConatiner;
